import { render, staticRenderFns } from "./ProductMarkets.vue?vue&type=template&id=3ed7c3c4&"
import script from "./ProductMarkets.vue?vue&type=script&lang=js&"
export * from "./ProductMarkets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports